import { ImageIcon } from "lucide-react";
import type { Block } from "@/types/proposals";

interface MarketingGalleryBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
  onSelect: () => void;
}

export function MarketingGalleryBlock({ block, onSelect }: MarketingGalleryBlockProps) {
  const images = block.content.images || [];

  return (
    <div className="cursor-pointer hover:ring-2 hover:ring-primary/50 transition-all rounded p-6" onClick={onSelect}>
      <h3 className="text-xl font-bold mb-4 text-center">Our Work</h3>
      {images.length === 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="aspect-video bg-muted rounded flex items-center justify-center">
              <ImageIcon className="w-8 h-8 text-muted-foreground opacity-50" />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {images.map((img: string, i: number) => (
            <img key={i} src={img} alt={`Gallery ${i + 1}`} className="aspect-video object-cover rounded" />
          ))}
        </div>
      )}
    </div>
  );
}
